import { INPUT_TEXT_ERROR } from '@/app/components/forms/styles';
import { cnva } from '@/app/utils/cnva';

/**
 * Base label text style.
 */
export const labelTextStyled = cnva('', {
  variants: {
    theme: {
      light: 'text-gray-700',
      dark: 'text-gray-50',
    },
  },
});

/**
 * Secondary label text style.
 */
export const labelSecondaryTextStyled = cnva('', {
  variants: {
    theme: {
      light: 'text-gray-600',
      dark: 'text-gray-200',
    },
  },
});

/**
 * Label required mark style (usually red color).
 */
export const labelRequiredStyled = cnva('', {
  variants: {
    theme: {
      light: INPUT_TEXT_ERROR,
      dark: INPUT_TEXT_ERROR,
    },
  },
});

/**
 * Help text style under the input.
 */
export const helpTextStyled = cnva('', {
  variants: {
    theme: {
      light: 'text-gray-500',
      dark: 'text-gray-200',
    },
    error: {
      true: INPUT_TEXT_ERROR,
    },
  },
});
